export default "__VITE_ASSET__DSG_n$Aq__"